"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeContants = require("../../../constants/themeContants");

var _theming = require("../../../theming");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The ItemGroup object creates spacing between all its children and wraps the items when there is no room
 */
var ItemGroup = function ItemGroup(_ref) {
  var children = _ref.children,
      spacing = _ref.spacing,
      variant = _ref.variant,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, ["children", "spacing", "variant", "className"]);

  return _react["default"].createElement(Wrap, _extends({
    variant: variant,
    className: className
  }, restProps), _react["default"].createElement(ItemGroupElement, {
    spacing: spacing,
    variant: variant
  }, children));
};

ItemGroup.themeProps = {
  wrapper: {
    name: "ITEM_GROUP_WRAPPER",
    description: "",
    type: _themeContants.themePropTypes.style
  },
  group: {
    name: "ITEM_GROUP",
    description: "",
    type: _themeContants.themePropTypes.style
  }
};

var Wrap = _styledComponents["default"].div.withConfig({
  displayName: "ItemGroup__Wrap",
  componentId: "sc-1lej1a6-0"
})(["overflow:hidden;", ";"], (0, _theming.applyVariants)(ItemGroup.themeProps.wrapper));

var ItemGroupElement = _styledComponents["default"].div.withConfig({
  displayName: "ItemGroup__ItemGroupElement",
  componentId: "sc-1lej1a6-1"
})(["display:flex;flex-wrap:wrap;margin:0 -", " -", ";& > *{margin:0 ", " ", ";}", ";"], function (p) {
  return (0, _theming.spacing)(p.spacing);
}, function (p) {
  return (0, _theming.spacing)(p.spacing);
}, function (p) {
  return (0, _theming.spacing)(p.spacing);
}, function (p) {
  return (0, _theming.spacing)(p.spacing);
}, (0, _theming.applyVariants)(ItemGroup.themeProps.group));

ItemGroup.propTypes = {
  children: _themeContants.commonPropTypes.children.isRequired,
  spacing: _themeContants.commonPropTypes.spacing
};
ItemGroup.defaultProps = {
  spacing: "tiny"
};
var _default = ItemGroup;
exports["default"] = _default;